import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import CampaignList from 'Components/Presentation/Campaigns/CampaignList';
import CampaignEditContainer from './Edit';

import AllAdvertisersQuery from 'GraphQueries/Advertisers/AllQuery';
import AllCampaignsQuery from 'GraphQueries/Campaigns/AllQuery';
import NewCampaignMutation from 'GraphQueries/Campaigns/NewMutation';
import NewCampaignSubscription from 'GraphQueries/Campaigns/NewSubscription';
import DeleteCampaignMutation from 'GraphQueries/Campaigns/DeleteMutation';
import DeleteCampaignSubscription from 'GraphQueries/Campaigns/DeleteSubscription';

class CampaignIndexContainer extends React.Component {

    static defaultProps = {
        campaigns: [],
        loading: false
    }

    state = {
        campaign: null,
        saving: false,
        processing: false
    }

    componentDidMount() {
        const { subscribeToChanges } = this.props;
        subscribeToChanges();
    }

    navigateWithData = (uri, campaign) => {
        const { history } = this.props;
        this.setState({ campaign });
        history.push(uri);
    }

    saveCampaign = async (campaign) => {
        const { onAlert, onAdd } = this.props;
        this.setState({ saving: true });
        onAdd(campaign).then(x => {
            this.setState({ saving: false });
            this.navigateWithData(`/media/campaigns/${campaign.id}/v1/manage/media-plan`, campaign);
            onAlert('success', `Successfully added campaign: ${campaign.id}`);
        }).catch(error => {
            if (error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to add campaigns, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    deleteCampaign = async (campaign) => {
        const { onAlert, onDelete } = this.props;
        this.setState({ saving: true });
        onDelete(campaign.id, campaign.version).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully deleted campaign: ${campaign.id}`);
        }).catch(error => {
            if (error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to delete campaigns, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    loadCampaigns = async(campaigns) => {        
        const { onLoadMore } = this.props;        
        this.setState({ processing: true });
        onLoadMore(campaigns).then(x => {
            this.setState({ processing: false });
        });
    }

    render() {
        const { campaigns, advertisers, loading, advertisersLoading } = this.props;
        const { campaign, saving, processing } = this.state;
        return (
            <React.Fragment>
                <Route path="/media/campaigns" exact render={props => { 
                    return (
                        <CampaignList {...props} loading={loading || advertisersLoading || saving} processing={processing} advertisers={advertisers} 
                            advertisersLoading={advertisersLoading} onEdit={this.navigateWithData} campaigns={campaigns} onCampaignAdded={this.saveCampaign} 
                            onCampaignRemoved={this.deleteCampaign} onLoadCampaigns={this.loadCampaigns} /> 
                    )}
                } />
                <Route path="/media/campaigns/list" render={props => { 
                    return (
                        <CampaignList {...props} loading={loading || advertisersLoading || saving} processing={processing} advertisers={advertisers} 
                            advertisersLoading={advertisersLoading} onEdit={this.navigateWithData} campaigns={campaigns} onCampaignAdded={this.saveCampaign} 
                            onCampaignRemoved={this.deleteCampaign} onLoadCampaigns={this.loadCampaigns} /> 
                    )}
                } />
                <Route path="/media/campaigns/:id/v:version/manage" render={routeProps => {
                    return (
                        <CampaignEditContainer {...this.props} {...routeProps} campaign={campaign} />
                    )}
                } />
            </React.Fragment>
        );
    }
}

export default compose(
    graphql(AllAdvertisersQuery(['brands']), {
        props: ({ data: { listAdvertisers, loading } }) => ({ advertisers: listAdvertisers && listAdvertisers.items, advertisersLoading: loading })
    }),
    graphql(AllCampaignsQuery(['version', 'advertiser { name }', 'startDate', 'endDate']), {
        props: ({ data: { listCampaigns, loading, subscribeToMore, fetchMore } }) => ({ 
            campaigns: listCampaigns,
            loading,
            subscribeToChanges: params => {
                subscribeToMore({
                    document: NewCampaignSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateCampaign } } }) => ({
                        ...prev,
                        listCampaigns: { items: [onCreateCampaign, ...prev.listCampaigns.items.filter(item => item.id !== onCreateCampaign.id)], __typename: 'CampaignConnection' }
                    })
                });
                subscribeToMore({
                    document: DeleteCampaignSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteCampaign } } }) => ({
                        ...prev,
                        listCampaigns: { items: [...prev.listCampaigns.items.filter(item => item.id !== onDeleteCampaign.id)], __typename: 'CampaignConnection' }
                    })
                });
            },
            onLoadMore: params => {
                return fetchMore({
                    variables: { nextToken: listCampaigns.nextToken },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        const newCampaigns = fetchMoreResult.listCampaigns.items;
                        const token = fetchMoreResult.listCampaigns.nextToken;

                        return newCampaigns.length
                            ? {
                                listCampaigns: {
                                    __typename: 'CampaignConnection',
                                    items: [...previousResult.listCampaigns.items, ...newCampaigns],
                                    nextToken: token
                                }
                            }
                            : previousResult;
                    }
                }); 
            } 
        })
    }),
    graphql(NewCampaignMutation(), { props: ({ mutate }) => ({ onAdd: input => mutate({ variables: { input } }) }) }),
    graphql(DeleteCampaignMutation(), { props: ({ mutate }) => ({ onDelete: (id, version) => mutate({ variables: { id, version } }) }) })
)(CampaignIndexContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Campaigns/Index.js